// extracted by mini-css-extract-plugin
export var originalPrice = "_v3-0";